import { Info } from "lucide-react";
import { images, resort } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function MonthlyRates() {
  return (
    <section
      id="monthly"
      aria-labelledby="monthly-rates-heading"
      className="scroll-mt-16 bg-background py-16 md:py-20"
    >
      <div className="shell">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="order-1 lg:col-span-5 lg:order-none" y={36}>
            <img
              src={images.accommodations}
              alt="Extended monthly RV stay site at Auburn RV Resort"
              width={1200}
              height={1400}
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover"
            />
          </Reveal>

          <div className="order-2 lg:col-span-7 lg:order-none lg:pl-4">
            <Reveal>
              <Eyebrow>Stay a Little Longer</Eyebrow>
            </Reveal>
            <h2 id="monthly-rates-heading" className="display-lg mt-6 max-w-[18ch]">
              <MaskReveal>Monthly &amp; Extended</MaskReveal>
              <MaskReveal delay={0.08}>RV Stays</MaskReveal>
            </h2>

            <Reveal delay={0.08}>
              <div className="mt-10">
                <p className="eyebrow text-muted-foreground">From</p>
                <p className="font-display mt-2 text-6xl tracking-tight text-primary md:text-7xl">
                  $1,260
                </p>
                <p className="mt-2 text-sm uppercase tracking-[0.18em] text-muted-foreground">
                  per month
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.12}>
              <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground">
                For guests planning a longer stay in Auburn, a limited number of RV sites may be
                available on a month-to-month basis. Extended-stay availability is different from
                short-term reservations and may require additional screening and approval. Monthly
                RV sites in Auburn CA start at $1,260.
              </p>
            </Reveal>

            <Reveal delay={0.16}>
              <aside className="mt-10 border border-border bg-secondary/40 p-6 md:p-8">
                <div className="flex gap-4">
                  <span className="flex size-10 shrink-0 items-center justify-center rounded-full border border-border bg-background text-primary">
                    <Info className="size-5" strokeWidth={1.5} aria-hidden="true" />
                  </span>
                  <div>
                    <p className="eyebrow text-foreground">Extended Stay Availability</p>
                    <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                      Extended-stay inventory may be limited and Auburn RV Resort may operate a
                      waitlist during certain periods. Placement on the waitlist does not guarantee
                      that a site will become available.
                    </p>
                  </div>
                </div>
              </aside>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
                <ResortLink variant="gold" href="/reservations/" className="w-full sm:w-auto">
                  Ask About Monthly Availability
                </ResortLink>
                <ResortLink variant="outline" href={resort.phoneHref} className="w-full sm:w-auto">
                  Call the Resort
                </ResortLink>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
